




























import {Component, Prop, Vue} from 'vue-property-decorator';
import LoadingIndicator from '@/components/common/LoadingIndicator.vue';

@Component({
  components: {
    LoadingIndicator,
  },
})
export default class CollapsibleTable extends Vue {
  public isOpened = true;

  @Prop() private title!: string;
  @Prop() private translate!: {};
  @Prop() private isLoading!: boolean;
}
